module.exports = __webpack_public_path__ + "static/btn 2_000014.d342dc81.png";